module.exports = __webpack_public_path__ + "079e22bbaefcbfb694ff75c53b52f321.png";